import { FaCircle, FaTv } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  setMarketName,
  setRunningData,
} from "../../../AsianExchangeSrc/redux/slices/fullmarketSlice";

export default function ScoreTable({ Matches }) {
  const dispatch = useDispatch();

  return (
    <div className="w-full h-[420px] overflow-y-auto">
      {Matches?.data
        ?.slice()
        ?.sort((a, b) => {
          const aInPlay = a?.matchOdds?.some((odds) => odds?.inplay);
          const bInPlay = b?.matchOdds?.some((odds) => odds?.inplay);
          if (bInPlay && !aInPlay) return 1;
          if (aInPlay && !bInPlay) return -1;
          return 0;
        })
        .map((event, index) => {
          const filteredOdds = event?.matchOdds?.find(
            (odds) => odds?.marketId === event?.marketId
          );

          if (event?.marketName !== "Match Odds") {
            return null;
          }
          let eventID;
          if (event?.sportName === "Cricket") {
            eventID = 4;
          } else if (event?.sportName === "Soccer") {
            eventID = 1;
          } else if (event?.sportName === "Tennis") {
            eventID = 2;
          }
          return (
            <div
              key={index}
              className="w-full border-b border-gray-300 flex text-xs font-medium flex-col md:flex-row"
              onClick={() => {
                dispatch(setRunningData(event?.matchRunners));
                dispatch(setMarketName(event?.markets));
              }}
            >
              {/* Game and Date */}
              <Link
                to={`/fullmarket?eventType=${eventID}&eventId=${event?.eventId}&marketId=${event?.marketId}&joinedMarketIds=${event?.joinedMarketIds}&competitionId=${event?.competitionId}&bm=${event?.bm}&fancy=${event?.fancy}&pc=${event?.pc}&eventName=${event.eventName}`}
                className="flex md:items-center gap-1 w-[100%] md:w-[45%] px-0 md:px-2 h-[30px] md:h-[40px] flex-col md:flex-row truncate"
              >
                <span className="font-bold text-[#333]">{event.eventName}</span>
                <span className="-mt-1 md:-mt-0 text-[11px] text-[#333]">
                  {new Date(event.openDate).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </span>
              </Link>

              {/* Icons - Fixed space */}

              <div className="flex md:hidden w-[100%] justify-between md:w-[65%]">
                <p className="w-[33.33%] font-bold flex justify-center py-0.5">
                  1
                </p>
                <p className="w-[33.33%] font-bold flex justify-center py-0.5">
                  x
                </p>
                <p className="w-[33.33%] font-bold flex justify-center py-0.5">
                  2
                </p>
              </div>

              <div className="flex w-[100%] md:w-[65%] font-bold border-b border-[#ddd] pb-1">
                <div className="md:flex gap-2 px-2  h-8 items-center hidden">
                  <div className="w-6 flex justify-center items-center">
                    <FaCircle className="text-green-500 text-[10px]" />
                  </div>
                  <div className="w-6 flex justify-center items-center">
                    <FaTv className="text-sm text-black" />
                  </div>
                  {event?.fancy && (
                    <div className="w-6 flex justify-center items-center">
                      <span className="font-bold text-[10px]">f</span>
                    </div>
                  )}

                  {event?.bm && (
                    <div className="w-6 flex justify-center items-center">
                      <span className="font-bold text-[10px]">B</span>
                    </div>
                  )}
                </div>

                {/* Odds */}

                <div className="flex items-center ml-auto pr-0 md:pr-2 w-full justify-end">
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#72BBEF] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToBack[0]?.price ||
                      "-"}
                  </div>
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#FAA9BA] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToLay[0]?.price ||
                      "-"}
                  </div>
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#72BBEF] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToBack[1]?.price ||
                      "-"}
                  </div>
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#FAA9BA] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToLay[1]?.price ||
                      "-"}
                  </div>
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#72BBEF] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToBack[2]?.price ||
                      "-"}
                  </div>
                  <div className="w-full md:w-[70px] h-7 flex justify-center items-center bg-[#FAA9BA] text-[#273a47] text-[12px]">
                    {filteredOdds?.runners[0]?.ex?.availableToLay[2]?.price ||
                      "-"}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
}
